import { useTranslation } from 'react-i18next';

type AgeVerificationPopupProps = {
  onClose: (isAgeVerified?: boolean) => void;
}

export const AgeVerificationPopup = ({ onClose }: AgeVerificationPopupProps) => {
  const { t } = useTranslation();

  return (
    <div className="bg-walletConnectBlur fixed inset-0 z-50 flex items-center justify-center px-2">
      <div
        className="bg-dashboard_box_blue relative flex w-full max-w-[804px] flex-col items-center gap-[10px] rounded-lg border border-b-4 border-black px-8 py-10 shadow-lg"
      >
        <h1 className="text-neon_yellow font-border poppins-3xl text-center text-[36px] font-[900] uppercase tracking-[-1px] md:text-left">
          {t('ageVerificationPopup.title')}
        </h1>
        <p className="bg-box_dark_blue font-border poppins-md w-full rounded-[4px] px-4 py-5 text-center text-[17px] normal-case">
          {t('ageVerificationPopup.description')}
        </p>
        <div className="flex w-full flex-col gap-[10px] py-[10px] md:flex-row">
          <button type="button" className="font-border poppins-lg red-button h-[66px] w-full" onClick={() => onClose()}>
            {t('ageVerificationPopup.rejectButton')}
          </button>
          <button
            type="button"
            className="font-border poppins-lg green-button h-[66px] w-full md:min-w-[410px]"
            onClick={() => onClose(true)}
          >
            {t('ageVerificationPopup.approveButton')}
          </button>
        </div>
      </div>
    </div>
  );
};
